/* eslint-disable */

// The MIT License (MIT)

// Copyright (c) 2014 Jameson Little

// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:

// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.

// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

// Adapted from https://github.dev/beatgammit/base64-js/blob/88957c9943c7e2a0f03cdf73e71d579e433627d3/index.js#L119

const lookup: string[] = [];

const code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for (let i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]!;
}

function tripletToBase64(num: number): string {
  return lookup[(num >> 18) & 0x3f]! + lookup[(num >> 12) & 0x3f]! + lookup[(num >> 6) & 0x3f]! + lookup[num & 0x3f]!;
}

function encodeChunk(uint8: Uint8Array | number[], start: number, end: number): string {
  let tmp;
  const output = [];
  for (let i = start; i < end; i += 3) {
    tmp = ((uint8[i]! << 16) & 0xff0000) + ((uint8[i + 1]! << 8) & 0xff00) + (uint8[i + 2]! & 0xff);
    output.push(tripletToBase64(tmp));
  }
  return output.join('');
}

/**
 * Converts a Uint8Array or Array of bytes into a string representation of base64.
 */
export function base64StringFromByteArray(uint8: Uint8Array | number[]): string {
  let tmp;
  const len = uint8.length;
  const extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
  const parts = [];
  const maxChunkLength = 16383; // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (let i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]!;
    parts.push(`${lookup[tmp >> 2]! + lookup[(tmp << 4) & 0x3f]!}==`);
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2]! << 8) + uint8[len - 1]!;
    parts.push(`${lookup[tmp >> 10]! + lookup[(tmp >> 4) & 0x3f]! + lookup[(tmp << 2) & 0x3f]!}=`);
  }

  return parts.join('');
}
